import React from 'react';
import Data from "./Data";
import $ from "jquery";
import AES128 from "./AES128";
import {BsChevronLeft} from 'react-icons/bs';
import { BiTimeFive } from 'react-icons/bi';
import { useEffect } from 'react';
import { Button, Card, Dropdown } from '@nextui-org/react';


function RegisterClassList(props) {
    
    
    useEffect(() => {
        // let studentname = sessionStorage.getItem('studentname');
        // let studentphone = sessionStorage.getItem('studentphone');

        // this.setState({
        //     studentname:studentname,
        //     studentphone:studentphone
        // });
    }, []);
    

    const handleMenu=(key)=> {
        $('#waitspinner').modal('show');

        let k = key.split("-");

        let token = AES128.encrypt(AES128.keyy,AES128.ivv,k[0]);

        var qp = new URLSearchParams(window.location.search);
        qp.set("token",token);
        sessionStorage.setItem('phone',k[1]);

        window.location.href = '/pay?'+qp.toString();
        
    }
    
        const {data, index} = props;

        return (
            <div className="col-12 col-md-6 col-lg-4 mb-4" key={index}>
                <Card className='text-right' isHoverable variant="bordered" css={{ p: "$6", mw: "400px" }}>
                    <Card.Header>
                        <div className='d-flex'>
                            <div style={{position:'relative', maxHeight:'72px',maxWidth:'72px'}}>
                            <img className="circle-icon"
                                height="72px"
                                width="72px"
                                src={data['masterpic']===''?Data.mainserver+"icons/user.png":Data.mainserver + "images/" + data['masterpic']}/>
                            <div className="circle-inst" 
                                style={{position:'absolute' , bottom:'-7px', left:'-7px'}}>
                                <img 
                                    height="25px"
                                    width="25px"
                                    src={Data.server+"icons/"+data['instrumentpic']}/>
                                </div>
                            
                            </div>
                            <div className='p-2'>
                                <h5 className="">{data['mastername']}</h5>
                                <h6 className='text-muted'>{data['instrumentname']}</h6>
                            </div>

                        </div>
                    </Card.Header>
                    <Card.Divider />
                    <Card.Body className='text-right' css={{ py: "$2" }}>
                        <Dropdown placement="bottom-center">
                            <Dropdown.Trigger>
                                <Button light icon={<BsChevronLeft fill="currentColor" />} color="secondary">
                                    مشاهده ساعت ها
                                </Button>
                            </Dropdown.Trigger>
                            <Dropdown.Menu
                                  aria-label="User menu actions"
                                  color="secondary"
                                  variant="solid"
                                  className='text-right'
                                  onAction={(actionKey) => handleMenu(actionKey)}
                                >
                                    {data['infos'].map((d,i) => 
                                        <Dropdown.Item 
                                            icon={<BiTimeFive className='mx-1' />}
                                            key={[d['id'],d['studentphone']].join("-")}
                                            css={{height:'fit-content', padding:'6px'}}
                                            color={d['reserved']==="yes"?"default":d['reserve']==="no"?"success":"error"}
                                            description={
                                            <div 
                                                style={{fontSize: '18px'}}>
                                                <div className='mt-1'>{d['studentname']!='null'&&d['studentname']!=null&&d['studentname']!=''?d['studentname']:""}</div>
                                                <div className='mt-2'>{d['reserve_time']}</div>
                                            </div>}>
                                            {d['time']}
                                            {d['reserved']==="yes"?"(غیر فعال)":d['reserve']==="no"?"(آزاد)":"(رزرو شده)"}
                                        </Dropdown.Item>
                                    )}
                                
                            </Dropdown.Menu>
                        </Dropdown>
                            
                    </Card.Body>
                </Card>
                
            </div>
        );
    
}


export default RegisterClassList;
